var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iv-base-form-group',_vm._b({},'iv-base-form-group',{ ..._vm.$attrs, ..._vm.$props, ..._vm.groupProps },false),[_c(_vm.cell,_vm._b({tag:"element"},'element',{ ..._vm.$attrs, ..._vm.$props, index: 0, rows: [], paging: {} },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }